@if (showLoadingSpinner()) {
	<div class="readonly">
		<div class="value-display loading"><i aria-hidden="true" class="fa fa-circle-o-notch fa-spin"></i></div>
	</div>
} @else {
	<p-autocomplete
		#filterControl
		dataKey="id"
		delay="0"
		dropdownMode="current"
		[ariaLabel]="placeholder()"
		[attr.data-test]="inputId() + '-filter'"
		[autoOptionFocus]="suggestions()?.length === 1"
		[completeOnFocus]="true"
		[dropdown]="true"
		[forceSelection]="true"
		[group]="!!groupItemsKey()"
		[inputId]="inputId()"
		[minLength]="0"
		[ngModel]="filterControlModel()"
		[optionDisabled]="optionDisabledProperty()"
		[optionLabel]="selectedOptionLabel()"
		[panelStyleClass]="suggestionsListWidth() === 'large' ? 'wide-suggestions' : undefined"
		[placeholder]="placeholder()"
		[readonly]="isReadonly()"
		[scrollHeight]="suggestionsListHeight"
		[suggestions]="suggestions()"
		(completeMethod)="onCompleteMethod($event)"
		(onBlur)="onFilterControlBlur()"
		(onFocus)="onFilterControlFocus()"
		(onSelect)="onValueChange($event.value?.id)"
		(onUnselect)="onValueChange(undefined)"
	>
		<ng-template #group let-group>
			{{ group.label }}
		</ng-template>
		<ng-template #item let-item>
			<!-- As we clear the selected option from the input on focus, we need to manually reintroduce highlighting of the selected option in the suggestions list -->
			<div
				[attr.data-test]="'option-' + item.id"
				[class.p-highlight]="selectedOption() && item.id === selectedOption().id"
			>
				<ng-template *ngTemplateOutlet="optionTemplate; context: { $implicit: item }" />
			</div>
		</ng-template>

		<ng-template #dropdownicon>
			<ng-template *ngTemplateOutlet="selectedOptionPrefixTemplate; context: { $implicit: selectedOption() }" />
		</ng-template>

		<ng-template #loadingicon />
	</p-autocomplete>
}
